(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // "Retour" button — return to the previous page the visitor was on.
    // Uses history.back() when there's history; otherwise follows the href
    // fallback (home). Never sends the user to a collection list.
    document.querySelectorAll('[data-renact-pdp-back]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.history.length > 1) { e.preventDefault(); window.history.back(); }
      });
    });

    document.querySelectorAll('[data-renact-add-to-cart]').forEach(function (form) {
      var qtyInput = form.querySelector('[data-renact-qty-input]');
      var decr = form.querySelector('[data-renact-qty-decr]');
      var incr = form.querySelector('[data-renact-qty-incr]');
      var submitBtn = form.querySelector('[data-renact-submit]');
      var submitDefault = form.querySelector('[data-renact-submit-default]');
      var submitLoading = form.querySelector('[data-renact-submit-loading]');
      var formMsg = form.querySelector('[data-renact-form-msg]');

      // Quantity stepper
      if (decr && qtyInput) decr.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
      });
      if (incr && qtyInput) incr.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });

      // AJAX add-to-cart with cart:updated dispatch
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (formMsg) { formMsg.setAttribute('hidden', ''); formMsg.textContent = ''; }
        if (submitBtn) submitBtn.setAttribute('disabled', '');
        if (submitDefault) submitDefault.setAttribute('hidden', '');
        if (submitLoading) submitLoading.removeAttribute('hidden');

        var formData = new FormData(form);
        fetch(form.getAttribute('action'), {
          method: 'POST',
          headers: { 'Accept': 'application/javascript' },
          body: formData,
        })
          .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
          .then(function (result) {
            if (!result.ok) {
              throw new Error((result.body && result.body.description) || 'Add to cart failed');
            }
            // Refresh cart state and broadcast
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            // Re-render + open the cart drawer via the global cart module, so the
            // added item appears immediately (previously only the count updated,
            // leaving the drawer empty until a page refresh).
            if (window.RenactCart && window.RenactCart.refreshAndOpen) {
              window.RenactCart.refreshAndOpen(cart);
            }
            if (formMsg) {
              formMsg.textContent = form.getAttribute('data-success-msg') || 'Ajouté au panier.';
              formMsg.setAttribute('data-state', 'success');
              formMsg.removeAttribute('hidden');
            }
          })
          .catch(function (err) {
            if (formMsg) {
              formMsg.textContent = err.message || 'Une erreur est survenue.';
              formMsg.setAttribute('data-state', 'error');
              formMsg.removeAttribute('hidden');
            }
          })
          .finally(function () {
            if (submitBtn) submitBtn.removeAttribute('disabled');
            if (submitDefault) submitDefault.removeAttribute('hidden');
            if (submitLoading) submitLoading.setAttribute('hidden', '');
          });
      });
    });

    document.querySelectorAll('[data-renact-sticky-cart]').forEach(function (stickyCart) {
      var section = stickyCart.previousElementSibling;
      var form = section && section.querySelector('[data-renact-add-to-cart]');
      var submitBtn = form && form.querySelector('[data-renact-submit]');
      var stickyBtn = stickyCart.querySelector('[data-renact-sticky-submit]');
      var qtyInput = form && form.querySelector('[data-renact-qty-input]');
      var qtyDecr = form && form.querySelector('[data-renact-qty-decr]');
      var qtyIncr = form && form.querySelector('[data-renact-qty-incr]');
      var stickyQtyInput = stickyCart.querySelector('[data-renact-sticky-qty-input]');
      var stickyQtyDecr = stickyCart.querySelector('[data-renact-sticky-qty-decr]');
      var stickyQtyIncr = stickyCart.querySelector('[data-renact-sticky-qty-incr]');
      if (!form || !submitBtn || !stickyBtn) return;

      function syncStickyButton() {
        stickyBtn.disabled = submitBtn.disabled;
        stickyBtn.setAttribute('aria-disabled', String(submitBtn.disabled));
        stickyBtn.textContent = submitBtn.innerText.trim();
      }

      function setQuantity(value) {
        var quantity = Math.max(1, parseInt(value, 10) || 1);
        if (qtyInput) qtyInput.value = quantity;
        if (stickyQtyInput) stickyQtyInput.value = quantity;
      }

      stickyBtn.addEventListener('click', function () {
        if (!submitBtn.disabled) form.requestSubmit(submitBtn);
      });

      if (stickyQtyDecr) stickyQtyDecr.addEventListener('click', function () {
        setQuantity((stickyQtyInput && stickyQtyInput.value) || 1);
        setQuantity(parseInt(stickyQtyInput.value, 10) - 1);
      });
      if (stickyQtyIncr) stickyQtyIncr.addEventListener('click', function () {
        setQuantity((stickyQtyInput && stickyQtyInput.value) || 1);
        setQuantity(parseInt(stickyQtyInput.value, 10) + 1);
      });
      if (stickyQtyInput) {
        stickyQtyInput.addEventListener('input', function () { setQuantity(stickyQtyInput.value); });
        stickyQtyInput.addEventListener('change', function () { setQuantity(stickyQtyInput.value); });
      }
      if (qtyInput) {
        qtyInput.addEventListener('input', function () { setQuantity(qtyInput.value); });
        qtyInput.addEventListener('change', function () { setQuantity(qtyInput.value); });
      }
      if (qtyDecr) qtyDecr.addEventListener('click', function () { setQuantity(qtyInput.value); });
      if (qtyIncr) qtyIncr.addEventListener('click', function () { setQuantity(qtyInput.value); });

      new MutationObserver(syncStickyButton).observe(submitBtn, {
        attributes: true,
        childList: true,
        subtree: true
      });
      syncStickyButton();
      setQuantity((qtyInput && qtyInput.value) || 1);

      new IntersectionObserver(function (entries) {
        stickyCart.setAttribute('data-visible', String(!entries[0].isIntersecting));
      }).observe(submitBtn);
    });

    // PDP gallery — thumb click swaps the active slide.
    document.querySelectorAll('[data-renact-pdp-gallery]').forEach(function (gallery) {
      var slides = gallery.querySelectorAll('[data-renact-pdp-slide]');
      var thumbs = gallery.querySelectorAll('[data-renact-pdp-thumb]');
      if (slides.length < 2 || thumbs.length < 2) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-renact-pdp-thumb');
          slides.forEach(function (s) {
            s.setAttribute('data-active', String(s.getAttribute('data-renact-pdp-slide') === idx));
          });
          thumbs.forEach(function (t) {
            var active = t.getAttribute('data-renact-pdp-thumb') === idx;
            t.setAttribute('data-active', String(active));
            t.setAttribute('aria-selected', String(active));
          });
        });
      });
    });

    // Expert-video modal: open from the swatch, close on X / backdrop / Esc.
    var expertOpen = document.querySelector('[data-renact-expert-open]');
    var expertModal = document.querySelector('[data-renact-expert-modal]');
    var expertClose = document.querySelector('[data-renact-expert-close]');
    if (expertOpen && expertModal && expertClose) {
      var expertVideo = expertModal.querySelector('video');
      function closeExpert() {
        expertModal.setAttribute('hidden', '');
        if (expertVideo) { try { expertVideo.pause(); } catch (e) {} }
        document.body.style.overflow = '';
      }
      function openExpert() {
        expertModal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        if (expertVideo) {
          try { expertVideo.currentTime = 0; } catch (e) {}
          // Autoplay only when the section is configured to — otherwise the
          // visitor uses the native play controls.
          var autoplay = expertModal.getAttribute('data-autoplay') === 'true';
          if (autoplay) {
            var p = expertVideo.play();
            if (p && typeof p.catch === 'function') { p.catch(function () {}); }
          }
        }
      }
      expertOpen.addEventListener('click', openExpert);
      expertClose.addEventListener('click', closeExpert);
      expertModal.addEventListener('click', function (e) { if (e.target === expertModal) closeExpert(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !expertModal.hasAttribute('hidden')) closeExpert();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Build a TOC from the article body's <h2> tags. Inject the pull quote at the midpoint.
  document.querySelectorAll('[data-renact-article-rte]').forEach(function (rte) {
    var article = rte.closest('.renact-article');
    if (!article) return;
    var tocWrap = article.querySelector('[data-renact-article-toc-wrap]');
    var toc = article.querySelector('[data-renact-article-toc]');
    var pullTpl = article.querySelector('[data-renact-article-pull-template]');
    var headings = rte.querySelectorAll('h2');
    if (toc && tocWrap && headings.length > 1) {
      var slugify = function (s) {
        return s.toLowerCase()
          .normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');
      };
      headings.forEach(function (h, i) {
        var id = h.id || slugify(h.textContent || ('section-' + i));
        h.id = id;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        var num = document.createElement('span');
        num.className = 'renact-article__toc-num';
        num.textContent = String(i + 1).padStart(2, '0');
        var label = document.createElement('span');
        label.className = 'renact-article__toc-label';
        label.textContent = h.textContent || '';
        a.appendChild(num);
        a.appendChild(label);
        li.appendChild(a);
        toc.appendChild(li);
      });
      tocWrap.removeAttribute('hidden');
    }
    // Pull quote injection at midpoint of <h2> sections
    if (pullTpl && headings.length > 0) {
      var midIndex = Math.floor(headings.length / 2);
      var anchor = headings[midIndex];
      if (anchor && anchor.nextSibling) {
        // Find the next <h2> (end of the midpoint section) and insert before it
        var nextH2 = headings[midIndex + 1];
        var clone = pullTpl.content.cloneNode(true);
        if (nextH2) rte.insertBefore(clone, nextH2);
        else rte.appendChild(clone);
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-renact-blog-list]').forEach(function (root) {
    var filters = root.querySelectorAll('[data-renact-blog-filter]');
    var grid = root.querySelector('[data-renact-blog-grid]');
    var empty = root.querySelector('[data-renact-blog-empty]');
    if (!grid) return;
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-renact-blog-filter');
        filters.forEach(function (b) {
          var active = b === btn;
          b.setAttribute('data-active', String(active));
          b.setAttribute('aria-selected', String(active));
        });
        var visible = 0;
        grid.querySelectorAll('.renact-blog__card').forEach(function (card) {
          var match = cat === '__all__' || card.getAttribute('data-category') === cat;
          card.setAttribute('data-hidden', String(!match));
          if (match) visible += 1;
        });
        if (empty) {
          if (visible === 0) empty.removeAttribute('hidden');
          else empty.setAttribute('hidden', '');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-renact-coll-accordion]').forEach(function (acc) {
      acc.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-renact-accordion-trigger]');
        if (!trigger) return;
        var item = trigger.closest('[data-renact-accordion-item]');
        if (!item) return;
        var isOpen = item.getAttribute('data-open') === 'true';
        acc.querySelectorAll('[data-renact-accordion-item]').forEach(function (el) {
          if (el !== item) {
            el.setAttribute('data-open', 'false');
            var t = el.querySelector('[data-renact-accordion-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        item.setAttribute('data-open', String(!isOpen));
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-discount-popup"] && !Shopify.designMode) return;
  try {
    
    (function () {
      // One global popup. Triggers after `delay` seconds on first eligible
      // page load, unless the visitor previously dismissed it (per the
      // selected frequency).
      class RenactDiscountPopup extends HTMLElement {
        connectedCallback() {
          this.delay = parseInt(this.getAttribute('data-delay'), 10) || 5;
          this.frequency = this.getAttribute('data-frequency') || 'session';
          this.storageKey = 'renact-popup-dismissed';
          this.discountCode = this.getAttribute('data-discount') || '';

          if (this.shouldSkip()) return;

          var self = this;
          this.timer = window.setTimeout(function () { self.show(); }, this.delay * 1000);

          // Close interactions
          this.querySelectorAll('[data-renact-popup-close]').forEach(function (el) {
            el.addEventListener('click', function () { self.dismiss(); });
          });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !self.hasAttribute('hidden')) self.dismiss();
          });

          // If user just submitted the form successfully (page reloaded with
          // form.posted_successfully? = true), show the popup immediately so
          // they see the confirmation/code rather than waiting `delay` seconds.
          if (this.querySelector('[data-renact-popup-success]')) {
            window.clearTimeout(this.timer);
            this.show();
          }
        }

        shouldSkip() {
          try {
            if (this.frequency === 'always') return false;
            var raw = (this.frequency === 'session')
              ? sessionStorage.getItem(this.storageKey)
              : localStorage.getItem(this.storageKey);
            if (!raw) return false;
            if (this.frequency === 'once') return true;
            if (this.frequency === 'session') return true;
            // 7d / 30d → raw is an ISO timestamp
            var dismissed = new Date(raw).getTime();
            var threshold = (this.frequency === '7d' ? 7 : 30) * 24 * 60 * 60 * 1000;
            return (Date.now() - dismissed) < threshold;
          } catch (e) { return false; }
        }

        show() {
          this.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        }

        dismiss() {
          this.setAttribute('hidden', '');
          document.body.style.overflow = '';
          try {
            var value = new Date().toISOString();
            if (this.frequency === 'session') {
              sessionStorage.setItem(this.storageKey, value);
            } else if (this.frequency !== 'always') {
              localStorage.setItem(this.storageKey, value);
            }
          } catch (e) { /* storage unavailable — accept the loss */ }
        }
      }
      if (!customElements.get('renact-discount-popup')) {
        customElements.define('renact-discount-popup', RenactDiscountPopup);
      }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-feelings-circle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Find every feelings section (there can technically be more than one
    // on a page) and wire it up independently. We use event delegation on
    // the section root rather than per-swatch listeners so it survives any
    // future markup changes inside the swatches.
    document.querySelectorAll('[data-renact-feelings]').forEach(function (root) {
      // The tagline-wrap is OUTSIDE the [data-renact-feelings] circle (it's
      // a sibling under .renact-feelings__stage), so we have to query the
      // hosting section, not the root, to find the hint/active elements.
      var hostSection = root.closest('section') || root;
      var defaultHint = hostSection.querySelector('[data-renact-feelings-default-hint]');
      var activeWrap = hostSection.querySelector('[data-renact-feelings-active]');
      var nameEl = hostSection.querySelector('[data-renact-feelings-active-name]');
      var taglineEl = hostSection.querySelector('[data-renact-feelings-active-tagline]');

      function show(swatch) {
        if (!swatch) return;
        var name = swatch.getAttribute('data-feeling-name') || '';
        var tagline = swatch.getAttribute('data-feeling-tagline') || '';
        if (defaultHint) defaultHint.setAttribute('hidden', '');
        if (activeWrap) activeWrap.removeAttribute('hidden');
        if (nameEl) nameEl.textContent = name;
        if (taglineEl) taglineEl.textContent = tagline;
      }
      function clear() {
        if (activeWrap) activeWrap.setAttribute('hidden', '');
        if (defaultHint) defaultHint.removeAttribute('hidden');
      }

      // Pointer-based delegation (works on touch + mouse). We listen on the
      // whole hosting section so leaving the swatch but staying near the
      // tagline keeps the active state until the user truly moves away.
      hostSection.addEventListener('pointerover', function (e) {
        var sw = e.target.closest('[data-feeling-name]');
        if (sw && root.contains(sw)) show(sw);
      });
      hostSection.addEventListener('pointerout', function (e) {
        var sw = e.target.closest('[data-feeling-name]');
        if (!sw) return;
        // pointerout fires when crossing into a child; ignore that case.
        if (e.relatedTarget && sw.contains(e.relatedTarget)) return;
        clear();
      });

      // Keyboard support
      hostSection.addEventListener('focusin', function (e) {
        var sw = e.target.closest('[data-feeling-name]');
        if (sw && root.contains(sw)) show(sw);
      });
      hostSection.addEventListener('focusout', function (e) {
        var sw = e.target.closest('[data-feeling-name]');
        if (!sw) return;
        if (e.relatedTarget && sw.contains(e.relatedTarget)) return;
        clear();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.renact-header').forEach(function (header) {
      var burger = header.querySelector('[data-renact-burger]');
      var mobile = header.querySelector('.renact-header__mobile');
      if (!burger || !mobile) return;

      burger.addEventListener('click', function () {
        var open = header.getAttribute('data-mobile-open') === 'true';
        header.setAttribute('data-mobile-open', String(!open));
        burger.setAttribute('aria-expanded', String(!open));
        if (open) {
          mobile.setAttribute('hidden', '');
          document.body.style.overflow = '';
        } else {
          mobile.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        }
      });

      // Mobile audio proxy — clicks the real header audio button and mirrors state
      var audioBtn = header.querySelector('[data-renact-audio-toggle]');
      var proxy = header.querySelector('[data-renact-mobile-audio-proxy]');
      if (audioBtn && proxy) {
        proxy.addEventListener('click', function (e) {
          e.preventDefault();
          audioBtn.click();
        });
        var syncProxy = function () {
          var playing = audioBtn.getAttribute('data-playing') === 'true';
          proxy.setAttribute('data-playing', String(playing));
          var label = playing
            ? proxy.getAttribute('data-audio-pause-label')
            : proxy.getAttribute('data-audio-play-label');
          proxy.setAttribute('aria-label', label);
          var labelEl = proxy.querySelector('[data-label]');
          if (labelEl) labelEl.textContent = label;
        };
        syncProxy();
        new MutationObserver(syncProxy).observe(audioBtn, {
          attributes: true, attributeFilter: ['data-playing']
        });
      }
    });

    // Keep --header-height in sync so sticky offsets work for sections below.
    function syncHeaderHeight() {
      var h = document.querySelector('.renact-header');
      if (!h) return;
      document.body.style.setProperty('--header-height', h.offsetHeight + 'px');
      document.body.style.setProperty('--header-group-height', h.offsetHeight + 'px');
    }
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);

    // Transparent-at-top → solid-on-scroll. Toggles data-scrolled once the
    // page is scrolled past a small threshold so the header gains a backdrop.
    (function () {
      var header = document.querySelector('.renact-header');
      if (!header) return;
      var threshold = 24;
      function onScrollHeader() {
        header.setAttribute('data-scrolled', String(window.scrollY > threshold));
      }
      window.addEventListener('scroll', onScrollHeader, { passive: true });
      onScrollHeader();
    })();

    // Listen for Shopify cart updates and refresh the counter.
    document.addEventListener('cart:updated', function (event) {
      var count = (event && event.detail && event.detail.cart && event.detail.cart.item_count) || 0;
      document.querySelectorAll('[data-renact-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.setAttribute('data-empty', count > 0 ? 'false' : 'true');
      });
    });

    // Ambient music player — Lovable Navbar.tsx
    // Browsers block autoplay until first user gesture; we register one-shot
    // pointerdown/keydown listeners as a fallback when initial play() rejects.
    //
    // Play/pause state persists across page navigations via sessionStorage.
    // - 'playing'  → user explicitly playing; resume on next page (subject to
    //                autoplay restriction → fall back to first interaction)
    // - 'paused'   → user explicitly paused; do not auto-resume
    // - null       → no preference yet; honor section's autoplay setting
    var AUDIO_STATE_KEY = 'renact-audio-state';
    document.querySelectorAll('[data-renact-audio-toggle]').forEach(function (btn) {
      var raw = btn.getAttribute('data-audio-tracks') || '';
      var tracks = raw.split('|').filter(function (s) { return s && s.length > 0; });
      var vol = parseFloat(btn.getAttribute('data-audio-volume')) || 0.4;
      var autoplay = btn.getAttribute('data-audio-autoplay') === 'true';
      var shuffle = btn.getAttribute('data-audio-shuffle') === 'true';
      if (!tracks.length) return;

      // Optional shuffle on initial load (Fisher–Yates).
      if (shuffle && tracks.length > 1) {
        for (var i = tracks.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = tracks[i]; tracks[i] = tracks[j]; tracks[j] = tmp;
        }
      }

      var idx = 0;
      var audio = new Audio(tracks[idx]);
      audio.loop = (tracks.length === 1);  // loop a single track; advance playlist otherwise
      audio.volume = vol;
      audio.preload = 'none';

      // On track end, advance to the next and continue playing seamlessly.
      audio.addEventListener('ended', function () {
        if (tracks.length <= 1) return;  // single track already loops
        idx = (idx + 1) % tracks.length;
        audio.src = tracks[idx];
        audio.play().catch(function () {});
      });

      var playLabel = btn.getAttribute('data-audio-play-label') || 'Play music';
      var pauseLabel = btn.getAttribute('data-audio-pause-label') || 'Pause music';

      function setState(playing, persist) {
        btn.setAttribute('data-playing', String(playing));
        btn.setAttribute('aria-label', playing ? pauseLabel : playLabel);
        if (persist !== false) {
          try {
            sessionStorage.setItem(AUDIO_STATE_KEY, playing ? 'playing' : 'paused');
          } catch (e) { /* storage unavailable — ignore */ }
        }
      }

      function tryPlay() {
        var p = audio.play();
        if (p && typeof p.then === 'function') {
          p.then(function () { setState(true); }).catch(function () {
            // Autoplay blocked — wait for first interaction.
            var resume = function () {
              audio.play().then(function () { setState(true); }).catch(function () {});
              window.removeEventListener('pointerdown', resume);
              window.removeEventListener('keydown', resume);
            };
            window.addEventListener('pointerdown', resume, { once: true });
            window.addEventListener('keydown', resume, { once: true });
          });
        }
      }

      btn.addEventListener('click', function () {
        if (audio.paused) {
          audio.play().then(function () { setState(true); }).catch(function () {});
        } else {
          audio.pause();
          setState(false);
        }
      });

      // Resolve initial state from sessionStorage, falling back to autoplay.
      var saved = null;
      try { saved = sessionStorage.getItem(AUDIO_STATE_KEY); } catch (e) {}
      if (saved === 'paused') {
        // User explicitly paused on a previous page — stay paused, no toggle.
        setState(false, false);
      } else if (saved === 'playing') {
        // User wants music — try to resume (may need an interaction).
        tryPlay();
      } else if (autoplay) {
        tryPlay();
      } else {
        setState(false, false);
      }
    });

    // Mega menu carousel — toggle arrows when scroller overflows, scroll on click.
    document.querySelectorAll('[data-renact-megamenu-scroller]').forEach(function (scroller) {
      var mega = scroller.closest('[data-renact-megamenu]');
      var arrows = mega ? mega.querySelector('[data-renact-megamenu-arrows]') : null;
      var prev = mega ? mega.querySelector('[data-renact-megamenu-prev]') : null;
      var next = mega ? mega.querySelector('[data-renact-megamenu-next]') : null;
      if (!arrows || !prev || !next) return;

      function syncOverflow() {
        var overflows = scroller.scrollWidth > scroller.clientWidth + 1;
        arrows.setAttribute('data-show', String(overflows));
        if (overflows) arrows.removeAttribute('hidden');
        else arrows.setAttribute('hidden', '');
        // Toggle disabled state on edges
        var atStart = scroller.scrollLeft <= 1;
        var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;
        if (atStart) prev.setAttribute('disabled', ''); else prev.removeAttribute('disabled');
        if (atEnd) next.setAttribute('disabled', ''); else next.removeAttribute('disabled');
      }
      function scroll(dir) {
        scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: 'smooth' });
      }
      prev.addEventListener('click', function (e) { e.preventDefault(); scroll(-1); });
      next.addEventListener('click', function (e) { e.preventDefault(); scroll(1); });
      scroller.addEventListener('scroll', syncOverflow, { passive: true });
      // Re-check after panel opens (sizes available) and on resize
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(syncOverflow).observe(scroller);
      } else {
        window.addEventListener('resize', syncOverflow);
      }
      // Sync once mega menu opens (panel goes from hidden to visible)
      if (mega) {
        new MutationObserver(function () {
          if (mega.getAttribute('data-open') === 'true') {
            requestAnimationFrame(syncOverflow);
          }
        }).observe(mega, { attributes: true, attributeFilter: ['data-open'] });
      }
      syncOverflow();
    });

    // Mega menu — hover/focus opens, click toggles, ESC closes, click-outside closes.
    var megamenus = document.querySelectorAll('[data-renact-megamenu]');
    var openMega = null;
    function setMegaOpen(mega, open) {
      if (!mega) return;
      var trigger = mega.querySelector('[data-renact-megamenu-trigger]');
      var panel = mega.querySelector('[data-renact-megamenu-panel]');
      mega.setAttribute('data-open', String(open));
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
      if (panel) {
        if (open) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      }
      if (open) {
        if (openMega && openMega !== mega) setMegaOpen(openMega, false);
        openMega = mega;
      } else if (openMega === mega) {
        openMega = null;
      }
    }
    megamenus.forEach(function (mega) {
      var trigger = mega.querySelector('[data-renact-megamenu-trigger]');
      if (!trigger) return;
      var openTimer = null;
      var closeTimer = null;

      function open() {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { setMegaOpen(mega, true); }, 60);
      }
      function close() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { setMegaOpen(mega, false); }, 120);
      }

      mega.addEventListener('mouseenter', open);
      mega.addEventListener('mouseleave', close);
      trigger.addEventListener('focus', open);
      mega.addEventListener('focusout', function (e) {
        if (!mega.contains(e.relatedTarget)) close();
      });
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = mega.getAttribute('data-open') === 'true';
        setMegaOpen(mega, !isOpen);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openMega) {
        setMegaOpen(openMega, false);
        var trigger = openMega.querySelector('[data-renact-megamenu-trigger]');
        if (trigger) trigger.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (openMega && !openMega.contains(e.target)) setMegaOpen(openMega, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Parallax scale on scroll (Lovable: useScroll + useTransform 1 → 1.05).
    var bg = document.querySelector('[data-renact-hero-bg]');
    if (!bg) return;
    var section = bg.closest('.renact-hero');
    if (!section) return;

    var ticking = false;
    function update() {
      var rect = section.getBoundingClientRect();
      var height = section.offsetHeight || 1;
      // 0 when section top is at viewport top, 1 when bottom of section reaches viewport top.
      var progress = Math.max(0, Math.min(1, -rect.top / height));
      var clamped = Math.min(progress / 0.6, 1);
      bg.style.transform = 'scale(' + (1 + clamped * 0.05) + ')';
      // Fade content out as we scroll (matches heroOpacity 1 → 0)
      section.style.setProperty('--renact-hero-content-opacity', String(1 - clamped));
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-method-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-renact-tabs]').forEach(function (root) {
      var triggers = root.querySelectorAll('[data-renact-tab-trigger]');
      var panels = root.querySelectorAll('[data-renact-tab-panel]');

      function activate(tabId) {
        root.setAttribute('data-active-tab', tabId);
        triggers.forEach(function (t) {
          var on = t.getAttribute('data-tab-id') === tabId;
          t.setAttribute('data-active', String(on));
          t.setAttribute('aria-selected', String(on));
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-tab-id') === tabId;
          p.setAttribute('data-active', String(on));
          if (on) p.removeAttribute('hidden');
          else    p.setAttribute('hidden', '');
        });
      }

      triggers.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.getAttribute('data-tab-id')); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-product-showcase"] && !Shopify.designMode) return;
  try {
    
  // Showcase carousel — arrows scroll the scroller by ~one card width.
  (function () {
    document.querySelectorAll('[data-renact-showcase]').forEach(function (root) {
      var scroller = root.querySelector('[data-renact-showcase-scroller]');
      var prev = root.querySelector('[data-renact-showcase-prev]');
      var next = root.querySelector('[data-renact-showcase-next]');
      if (!scroller || !prev || !next) return;

      function step() {
        var card = scroller.querySelector('.renact-showcase__card');
        if (!card) return Math.max(240, scroller.clientWidth * 0.25);
        // Card width + gap (read computed gap from the scroller)
        var styles = getComputedStyle(scroller);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrowStates() {
        var atStart = scroller.scrollLeft <= 1;
        var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;
        prev.toggleAttribute('disabled', atStart);
        next.toggleAttribute('disabled', atEnd);
      }

      prev.addEventListener('click', function () {
        scroller.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        scroller.scrollBy({ left: step(), behavior: 'smooth' });
      });

      scroller.addEventListener('scroll', updateArrowStates, { passive: true });
      window.addEventListener('resize', updateArrowStates);
      updateArrowStates();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-renact-spotlight]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-renact-spotlight-slide]'));
      if (slides.length === 0) return;
      var prev = root.querySelector('[data-renact-spotlight-prev]');
      var next = root.querySelector('[data-renact-spotlight-next]');
      var currentEl = root.querySelector('[data-renact-spotlight-current]');
      var index = 0;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          var active = j === index;
          s.setAttribute('data-active', String(active));
          if (active) s.removeAttribute('aria-hidden');
          else        s.setAttribute('aria-hidden', 'true');
          // Reset accordions when navigating: open first, close others
          var items = s.querySelectorAll('[data-renact-accordion-item]');
          items.forEach(function (it, k) {
            var open = k === 0;
            it.setAttribute('data-open', String(open));
            var t = it.querySelector('[data-renact-accordion-trigger]');
            if (t) t.setAttribute('aria-expanded', String(open));
          });
        });
        if (currentEl) currentEl.textContent = String(index + 1);
      }

      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });

      // Accordion click behavior is handled globally by assets/renact-accordion.js.
      // We only reset accordion state when navigating slides (see show() above).
    });

    // Add-to-cart wiring lives in assets/renact-cart.js as a global delegated
    // submit listener (handles AJAX add + drawer refresh + drawer open).

    // Expert-video modals: open the modal whose data-block-index matches the
    // clicked swatch, pause/reset on close, restore body scroll. One modal
    // per block (rendered above) so each slide can carry its own video.
    var expertOpeners = document.querySelectorAll('[data-renact-spotlight-expert-open]');
    var expertModals = document.querySelectorAll('[data-renact-spotlight-expert-modal]');
    if (expertOpeners.length && expertModals.length) {
      var modalsByIndex = {};
      expertModals.forEach(function (m) { modalsByIndex[m.getAttribute('data-block-index')] = m; });

      function closeExpert(modal) {
        if (!modal) return;
        modal.setAttribute('hidden', '');
        var v = modal.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
        document.body.style.overflow = '';
      }
      function openExpert(modal) {
        if (!modal) return;
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        var v = modal.querySelector('video');
        if (v) {
          try { v.currentTime = 0; } catch (e) {}
          var autoplay = modal.getAttribute('data-autoplay') === 'true';
          if (autoplay) {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
        }
      }

      expertOpeners.forEach(function (btn) {
        btn.addEventListener('click', function () {
          openExpert(modalsByIndex[btn.getAttribute('data-block-index')]);
        });
      });
      expertModals.forEach(function (modal) {
        var closeBtn = modal.querySelector('[data-renact-spotlight-expert-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () { closeExpert(modal); });
        modal.addEventListener('click', function (e) { if (e.target === modal) closeExpert(modal); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        expertModals.forEach(function (m) { if (!m.hasAttribute('hidden')) closeExpert(m); });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Accordion behavior is now handled globally by assets/renact-accordion.js.

    // Founder carousel (left column) — cycles through quote + image slides.
    // Each slide carries its own prev/next pair (so the arrows can sit next to
    // its image). We bind clicks via event delegation on the carousel root.
    document.querySelectorAll('[data-renact-science-carousel]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-renact-science-slide]');
      if (slides.length < 2) return;
      var index = 0;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          var active = j === index;
          s.setAttribute('data-active', String(active));
          if (active) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
        });
      }

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-renact-science-prev]')) {
          e.preventDefault();
          show(index - 1);
        } else if (e.target.closest('[data-renact-science-next]')) {
          e.preventDefault();
          show(index + 1);
        }
      });

      // Keyboard arrows when focus is inside the carousel
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { show(index - 1); }
        if (e.key === 'ArrowRight') { show(index + 1); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renact-webinars"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-renact-webinars]').forEach(function (root) {
      var filters = root.querySelectorAll('[data-renact-webinars-filter]');
      var cards = root.querySelectorAll('[data-renact-webinars-card]');

      function activate(audience) {
        root.setAttribute('data-active', audience);
        filters.forEach(function (f) {
          var on = f.getAttribute('data-renact-webinars-filter') === audience;
          f.setAttribute('data-active', String(on));
          f.setAttribute('aria-selected', String(on));
        });
        cards.forEach(function (c) {
          var on = c.getAttribute('data-audience') === audience;
          if (on) c.removeAttribute('hidden');
          else c.setAttribute('hidden', '');
        });
      }

      filters.forEach(function (f) {
        f.addEventListener('click', function () {
          activate(f.getAttribute('data-renact-webinars-filter'));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
